import { Component } from '@angular/core';

@Component({
  selector: 'my-personal',
  styles: [],
  templateUrl: 'personal.component.html'
})

export class PersonalComponent {}



// WEBPACK FOOTER //
// ./src/app/personal/personal.component.ts